import { ColorRgba } from "@cc/pixi-app";

export const colors = {
    red: new ColorRgba(0xff0000),
    green: new ColorRgba("#00ff00"),
    blue: new ColorRgba({ b: 255 }),
    white: new ColorRgba(0xffffff),
    black: new ColorRgba()
};
